import { useEffect, useState } from "react";
import { fetchDolarHoy } from "../../api";
import type { DolarHoy } from "../../types";
import { fmtUsd, formatearMonto, montoANumero, type Moneda } from "./costosFormat";

/** Estado del monto de un costo: texto con miles, moneda CLP o USD y conversión con el dólar del día. */
export function useMontoCosto(inicialClp?: number) {
  const [moneda, setMoneda] = useState<Moneda>("CLP");
  const [texto, setTexto] = useState(inicialClp != null ? formatearMonto(String(Math.round(inicialClp)), "CLP") : "");
  const [dolar, setDolar] = useState<DolarHoy | null>(null);
  const [dolarFalla, setDolarFalla] = useState(false);

  useEffect(() => {
    fetchDolarHoy().then(setDolar).catch(() => setDolarFalla(true));
  }, []);

  const numero = montoANumero(texto);
  const esUsd = moneda === "USD";
  const montoClp = esUsd ? (dolar && !isNaN(numero) ? Math.round(numero * dolar.valor) : NaN) : numero;
  const detalleUsd = esUsd && dolar && !isNaN(numero) ? `${fmtUsd(numero)} × $${String(dolar.valor).replace(".", ",")} (dólar del ${dolar.fecha})` : null;

  return {
    moneda,
    cambiarMoneda: (m: Moneda) => { setMoneda(m); setTexto((t) => formatearMonto(t, m)); },
    texto,
    escribir: (raw: string) => setTexto(formatearMonto(raw, moneda)),
    dolar,
    dolarFalla,
    esUsd,
    montoClp,
    detalleUsd,
    /** La nota del usuario más el origen en dólares, cuando el monto se ingresó en USD. */
    notaFinal: (nota: string) => [nota.trim(), detalleUsd].filter(Boolean).join(" · ") || undefined,
  };
}
